import { render } from "./PreferencesPage.vue?vue&type=template&id=235da6dd&scoped=true&ts=true"
import script from "./PreferencesPage.vue?vue&type=script&lang=ts"
export * from "./PreferencesPage.vue?vue&type=script&lang=ts"

import "./PreferencesPage.vue?vue&type=style&index=0&id=235da6dd&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-235da6dd"],['__file',"src/views/PreferencesPage.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "235da6dd"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('235da6dd', __exports__)) {
    api.reload('235da6dd', __exports__)
  }
  
  module.hot.accept("./PreferencesPage.vue?vue&type=template&id=235da6dd&scoped=true&ts=true", () => {
    api.rerender('235da6dd', render)
  })

}


export default __exports__